// extracted by mini-css-extract-plugin
module.exports = {"container":"_2n_nd0-dB-4FWvWCqEFLr2","icon":"_1-eKc6FIoLkqLE2VrFaqrV"};